import dateFnsAddDays from 'date-fns/addDays'
import dateFnsAddMonths from 'date-fns/addMonths'
import dateFnsAddHours from 'date-fns/addHours'
import dateFnsAddMinutes from 'date-fns/addMinutes'
import dateFnsAddMillis from 'date-fns/addMilliseconds'
import differenceInDays from 'date-fns/differenceInDays'
import isValid from 'date-fns/isValid'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

type Unit = 'days' | 'months' | 'minutes' | 'hours' | 'milliseconds'
const _addOp = (u: Unit): { (d: Date, amount: number): Date } => {
  switch (u) {
    case 'days':
      return dateFnsAddDays
    case 'months':
      return dateFnsAddMonths
    case 'minutes':
      return dateFnsAddMinutes
    case 'hours':
      return dateFnsAddHours
    case 'milliseconds':
      return dateFnsAddMillis
  }
}

export const addDuration = (
  date: string | Date,
  amount = 0,
  unit: 'days' | 'months' | 'minutes' | 'hours' | 'milliseconds'
): string => {
  if (!amount) {
    return !date ? null : typeof date === 'string' ? date : date.toISOString()
  }
  const dateAsDate = typeof date === 'string' ? parseISO(date) : date
  if (isValid(dateAsDate)) {
    const addOp = _addOp(unit)

    const integerAmount = amount > 0 ? Math.floor(amount) : Math.ceil(amount)
    const newDate = addOp(dateAsDate, integerAmount)

    const missingPart = amount - integerAmount
    if (missingPart != 0) {
      // se amount for uma fração, não um valor inteiro, subtrai o que resta
      switch (unit) {
        case 'days':
          return addDuration(newDate, missingPart * 1000 * 60 * 60 * 24, 'milliseconds')
        case 'months':
          return addDuration(newDate, missingPart * 30 /* assume que o mês tem 30 dias, e paciência */, 'days')
        case 'hours':
          return addDuration(newDate, missingPart * 1000 * 60 * 60, 'milliseconds')
        case 'minutes':
          return addDuration(newDate, missingPart * 1000 * 60, 'milliseconds')
        case 'milliseconds':
          break
      }
    }

    if (typeof date === 'string' && date?.length === 10) {
      return formatISODay(newDate)
    }
    return newDate.toISOString()
  }
  return !date ? null : typeof date === 'string' ? date : date.toISOString()
}

export const addDays = (date: string | Date, amount: number): string => {
  return addDuration(date, amount, 'days')
}

export const addMonths = (date: string | Date, amount: number): string => {
  return addDuration(date, amount, 'months')
}

export const diffInDays = (start: string | Date, end: string | Date): number => {
  return differenceInDays(
    typeof start === 'string' ? parseISO(start) : start,
    typeof end === 'string' ? parseISO(end) : end
  )
}

/**
 * @returns Data de hoje no formato yyyy-MM-dd
 */
export const getToday = (): string => {
  return formatISODay(new Date())
}

/**
 * Para substituir uso do toISOString().substring(0, 10)
 */
export const formatISODay = (date: string | Date): string => {
  if (!date) return date as null
  if (typeof date === 'string' && date?.length === 10) return date
  return format(typeof date === 'string' ? parseISO(date) : date, 'yyyy-MM-dd')
}
